import {useRef,useMemo} from "react";
import NoteDetailPopup from '../Note/NoteDetailPopup.js';
import COMPONENT_MAP from '../Repository/Components.js';

const AccountDetailNotes=({parentId,application,userData})=>{
    const list_name='account_notes';
    const executeQuery=useRef(true);
    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={parentId}
                application={application}
                userData={userData}
                entityType={'Note'}
                entityParams={['account_id='+parentId,'_context='+['parent_name=Account'],'_lang='+application.globalData.lang]}
                list_name={list_name}
                // height={'50vh'}
                file={'AccountDetailNotes.js'}
                initialState={{}}
                navigateOnNew={null}
                checkboxSelection={true}
                disableRowSelectionOnClick={true}
                disableSelectionOnClick={true}
                popupComponent={NoteDetailPopup}
                parentContext={{parent_field_name:'account_id',parent_field_value:null,parent_name:'Account'}}
                executeQuery={executeQuery}
            />
        ):null; 
    },[parentId,application,userData]);

    return(renderListTab);
}
export default AccountDetailNotes;